export default "__VITE_ASSET__CrinRVN___"